export enum CustomHeaders {
  UserId = 'Kh-User-Id',
  GameId = 'X-Game-Id',
  Authorization = 'Authorization'
}
